import { memo } from "react";
import { ECommerce } from "ui/organizms/Onboarding";

const ECommerceApplication = () => (
    <ECommerce.ECommerceApplication />
);

export default memo(ECommerceApplication);
